import { AddPolicyComponent } from '../../../../../forms/dynamic-forms/add-policy/add-policy.component';
import { MapfreButtonComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreModalComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-modal/mapfre-modal.component';
import { MapfreCardComponent } from '../../../../../../modules/mapfre-design-library/src/lib/_components/wrapper-components/mapfre-card/mapfre-card.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit } from '@angular/core';
import { AddPolicyService } from './../../../../../../_services/forms/create-account/add-policy.service';
import { ModalOptions, AcmicService } from '@mapfre-design-library/src/public_api';
import { UserService } from './../../../../../../_services/user.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreCardComponent, MapfreModalComponent, MapfreButtonComponent, AddPolicyComponent],
  selector: 'app-link-policy',
  templateUrl: './link-policy.component.html',
})
export class LinkPolicyComponent implements OnInit {
  whereToFindModalOptions: ModalOptions;
  linkPolicy: any[];
  user: any;
  isAcmic: boolean;
  hideModal: boolean;
  continueButton = 'Continue';
  missingPolicyNumber: string;
  constructor(
    policyService: AddPolicyService,
    private userService: UserService,
    private acmicService: AcmicService
  ) {
    this.linkPolicy = policyService.getLinkInputs();
  }

  ngOnInit() {
    this.missingPolicyNumber = history.state.missingPolicyNumber;
    this.isAcmic = this.acmicService.isACMIC();
    let modalTranslateCopy = 'LOCATE_YOUR_POLICY_INFORMATION';
    let buttonCopy = 'WHERE_CAN_I_FIND_POLICY_INFO';
    if (this.isAcmic) {
      modalTranslateCopy = 'LOCATE_YOUR_POLICY_INFO';
      buttonCopy = 'MODAL_WHERE_CAN_I_LINK';
    }
    this.userService.$user.subscribe((user) => {
      this.user = user;
    });
    this.whereToFindModalOptions = new ModalOptions({
      additionalClasses: 'modal-small normal-case modal-dialog center-on-page',
      additionalButtonClasses: `no-padding-horizontal link-button small red-link underline ${
        this.isAcmic
          ? 'text-capitalize font-weight normal-text'
          : 'font-size-16 font-weight-500 dm-sans-medium'
      }`,
      animatePosition: 'bottom',
      modalId: 'helpModal',
      modalTranslateCopy,
      buttonCopy,
      typeOfModal: 'default',
      modalName: 'link-policy_Where_To_Find_Options',
    });
  }

  hideModalAction(): void {
    this.hideModal = !this.hideModal;
  }
  resetHideModal(): void {
    this.hideModal = !this.hideModal;
  }

}
